import { gql, useMutation } from '@apollo/client'
import { MappedModal, MappedModalProps } from '@mapped/rivet/dist/mapped/modal'
import { LoadingButton } from '@mapped/rivet/dist/mui/lab'
import { styled } from '@mapped/rivet/dist/mui/styles'
import { FunctionComponent, useState } from 'react'
import { logger } from '../../../../utils/logger'

const TokenDeleteConfirmationModal: FunctionComponent<
  ITokenDeleteConfirmationModalProps
> = ({ tokenId, onError, ...props }) => {
  const [isDeleting, setIsDeleting] = useState(false)

  const [deletePersonalAccessToken] = useMutation(
    DELETE_PERSONAL_ACCESS_TOKEN_MUTATION,
    {
      onError: (err) => logger.error('[delete pat mutation error]', err),
    }
  )

  async function onDelete() {
    try {
      setIsDeleting(true)

      await deletePersonalAccessToken({
        variables: {
          input: {
            id: tokenId,
          },
        },
        refetchQueries: ['tokens'],
        awaitRefetchQueries: true,
      })

      props.onClose?.()
    } catch (e: any) {
      onError()
      props.onClose?.()
    }
  }

  return (
    <MappedModal {...props} style={{ width: 460 }}>
      <Container>
        <Title>Are you sure you want to delete this token?</Title>

        <Text>
          Any applications or scripts using this token will no longer be able to
          access the Mapped API
        </Text>

        <LoadingButton
          color="error"
          onClick={onDelete}
          loading={isDeleting}
          style={{ width: '100%', marginTop: 32 }}
        >
          I understand, delete this token
        </LoadingButton>
      </Container>
    </MappedModal>
  )
}

const DELETE_PERSONAL_ACCESS_TOKEN_MUTATION = gql`
  mutation DeletePersonalAccessTokenRequest(
    $input: PersonalAccessTokenDeleteRequestInput
  ) {
    deletePersonalAccessToken(input: $input) {
      _
    }
  }
`

const Container = styled.div`
  padding: 36px;
  padding-bottom: 28px;
`

const Title = styled.h2`
  font-size: 32px;
  font-weight: 500;
  margin-bottom: 20px;
  margin-top: 0;
  text-align: center;
`

const Text = styled.p`
  font-size: 18px;
  text-align: center;
`

interface ITokenDeleteConfirmationModalProps extends MappedModalProps {
  tokenId: string
  onError: () => void
}

export default TokenDeleteConfirmationModal
